import DeliveryTables from '@/components/orders/tables/delivery-tables/DeliveryTables';
import ConfirmDispenseButton from '@/components/orders/tables/delivery-tables/processing-dispense/ConfirmDispenseButton';
import { DeliveryTableDataProvider } from '@/context/orders/DeliveryTableFilteredData';
import { ListOrdersView } from '@/hooks/orders/useListOrders';

function ProcessingDispenseTables() {
  return (
    <DeliveryTableDataProvider view={ListOrdersView.ProcessingDispense}>
      <DeliveryTables HeaderActions={<ConfirmDispenseButton />} />
    </DeliveryTableDataProvider>
  );
}

export default ProcessingDispenseTables;
